export default __webpack_public_path__ + "static/media/post9.b22beea1.jpg";